import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {TenantDto} from "../../model/TenantDto";
import TenantBooleanRadioFormGroup from "./TenantBooleanRadioFormGroup";
import NumberFormControl from "../form/NumberFormControl";


interface Props {
    show: boolean;
    onHide: () => void;
    submitCallback: (tenant: TenantDto) => void;
}

const schema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    employerSubsidyPercent: Yup.number().nullable(),
    employerSubsidyMonthlyEuros: Yup.number().nullable(),
    employerRetentionPercent: Yup.number().nullable(),
    employerRetentionMonthlyEuros: Yup.number().nullable(),
    requireConfirmation: Yup.boolean().required('Contribution is required'),
    isOrderExportEnabled: Yup.boolean().required('Contribution is required'),
    useGrossVehiclePrice: Yup.boolean().required('Contribution is required'),
    isMonetaryBenefitVatSalaryConversionEnabled: Yup.boolean().required('Contribution is required'),
});

const TenantModal: React.FC<Props> = ({ show, onHide, submitCallback, }) => {

    function getInitTenant(): TenantDto {
        return {id: 0, norm: '', title: '', employerSubsidyPercent: undefined, employerSubsidyMonthlyEuros: undefined, employerRetentionPercent: undefined, employerRetentionMonthlyEuros: undefined,  signupCode: '', contractInfo: '', workplaceAddress: undefined, parent: undefined, children: undefined, orderEmail: undefined, registerEmail: undefined, requireConfirmation: undefined, isOrderExportEnabled: undefined, mfaRequiredRoleNames: [], useGrossVehiclePrice: undefined, isMonetaryBenefitVatSalaryConversionEnabled: false, employerSubsidyThresholdType: "NONE"}
    }

    const formik = useFormik({
        initialValues: getInitTenant(),
        validationSchema: schema,
        onSubmit: values => {
            submitCallback(values);
            onHide();
        },
    });

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Create Tenant</Modal.Title>
            </Modal.Header>
            <Form onSubmit={formik.handleSubmit}>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            type="text"
                            name="title"
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            isInvalid={!!formik.errors.title}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.title}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Arbeitgeberzuschuss Prozent</Form.Label>
                        <NumberFormControl
                            type="number"
                            name="employerSubsidyPercent"
                            value={formik.values.employerSubsidyPercent}
                            onChange={formik.handleChange}
                            isInvalid={!!formik.errors.employerSubsidyPercent}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.employerSubsidyPercent}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Arbeitgeberzuschuss Euro</Form.Label>
                        <NumberFormControl
                            type="number"
                            name="employerSubsidyMonthlyEuros"
                            value={formik.values.employerSubsidyMonthlyEuros}
                            onChange={formik.handleChange}
                            isInvalid={!!formik.errors.employerSubsidyMonthlyEuros}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.employerSubsidyMonthlyEuros}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Arbeitgebereinbehalt Prozent</Form.Label>
                        <NumberFormControl
                            type="number"
                            name="employerRetentionPercent"
                            value={formik.values.employerRetentionPercent}
                            onChange={formik.handleChange}
                            isInvalid={!!formik.errors.employerRetentionPercent}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.employerRetentionPercent}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Arbeitgebereinbehalt Euro</Form.Label>
                        <NumberFormControl
                            type="number"
                            name="employerRetentionMonthlyEuros"
                            value={formik.values.employerRetentionMonthlyEuros}
                            onChange={formik.handleChange}
                            isInvalid={!!formik.errors.employerRetentionMonthlyEuros}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.employerRetentionMonthlyEuros}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Signup code</Form.Label>
                        <Form.Control
                            type="text"
                            name="signupCode"
                            value={formik.values.signupCode}
                            onChange={formik.handleChange}
                            isInvalid={!!formik.errors.signupCode}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.signupCode}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <TenantBooleanRadioFormGroup name={"requireConfirmation"} value={formik.values.requireConfirmation} setFieldValue={formik.setFieldValue} touched={formik.touched} errors={formik.errors}/>
                    <TenantBooleanRadioFormGroup name={"isOrderExportEnabled"} value={formik.values.isOrderExportEnabled} setFieldValue={formik.setFieldValue} touched={formik.touched} errors={formik.errors}/>
                    <TenantBooleanRadioFormGroup name={"useGrossVehiclePrice"} value={formik.values.useGrossVehiclePrice} setFieldValue={formik.setFieldValue} touched={formik.touched} errors={formik.errors}/>
                    <TenantBooleanRadioFormGroup name={"isMonetaryBenefitVatSalaryConversionEnabled"} value={formik.values.isMonetaryBenefitVatSalaryConversionEnabled} setFieldValue={formik.setFieldValue} touched={formik.touched} errors={formik.errors}/>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Close
                    </Button>
                    <Button  variant="primary" type="submit">
                        Create
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default TenantModal;
